import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { Observable } from 'rxjs';
import { countryResponse } from '../../models/country/countryResponse';
import { apiResponse } from '../../models/apiResponse';
import { OlaPlacesResponse } from '../../models/country/olaPlacesResponse';
import { environment } from '../../../environments/environment';
import { StateResponse } from '../../models/country/stateResponse';
import { Time } from '@angular/common';
import { TimeZoneResponse } from '../../models/peer/timeZoneResponse';
import { SearchByNameResponse } from '../../models/account/searchByNameResponse';
import { SearchByNameRequest } from '../../models/account/searchByNameRequest';
import { CountriesNowResponse } from '../../models/country/countriesNowResponse';
import { SearchByEmailResponse } from '../../models/account/searchByEmailResponse';
import { SearchByEmailRequest } from '../../models/account/searchByEmailRequest';
import { SearchByPhoneNumberRequest } from '../../models/account/searchByPhoneNumberRequest';
import { SearchByPhoneNumberResponse } from '../../models/account/searchByPhoneNumberResponse';
import { CityResponse } from '../../models/Institutedetails/CityResponse';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private genericService: GenericService) { }

  getCountries(): Observable<apiResponse<countryResponse[]>> {
    return this.genericService.get(`country`)
  }

  getCitiesByCountry(country: string): Observable<CountriesNowResponse> {
    const url = environment.apis.default.countriesNow.url;
    const body = {
      country: country
    }
    return this.genericService.postThirdPartyResponse(url, body);
  }

  getCitiesByProvinceId(provinceId: number): Observable<apiResponse<CityResponse[]>> {
    return this.genericService.get(`city/${provinceId}`);
  }

  getOLAPlaces(text: string): Observable<OlaPlacesResponse> {
    var uri = `${environment.apis.default.olaPlaces.url}?input=${text}&api_key=${environment.apis.default.olaPlaces.apiKey}`
    return this.genericService.getThirdPartyResponse(uri)
  }

  getProvinces(countrycode: string): Observable<apiResponse<StateResponse[]>> {
    return this.genericService.get(`states/${countrycode}`)
  }
  getTimeZones(): Observable<apiResponse<TimeZoneResponse[]>> {
    return this.genericService.get(`timezones`);
  }
  searchNamesByRole(searchByNameRequest: SearchByNameRequest): Observable<apiResponse<SearchByNameResponse[]>> {
    return this.genericService.post(`user/search`, searchByNameRequest);
  }
  searchEmailsByRole(searchByEmailRequest: SearchByEmailRequest): Observable<apiResponse<SearchByEmailResponse[]>> {
    return this.genericService.post(`user/search-by-email`, searchByEmailRequest);
  }
  searchPhoneNumbersByRole(searchByPhoneNumberRequest: SearchByPhoneNumberRequest): Observable<apiResponse<SearchByPhoneNumberResponse[]>> {
    return this.genericService.post(`user/search-by-phonenumber`, searchByPhoneNumberRequest);
  }
}
